import React from 'react'
import { Navigate } from 'react-router-dom'

export default function LabsRoute(props) {

  if(sessionStorage.getItem('desiredPage')==='labs'){
    return props.children
  }else{
    return <Navigate to={'/services'}/>
  }
}
